module.exports = __webpack_public_path__ + "static/media/liansheng-trailer.2e54782.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/liansheng-trailer.mp4
// module id = lzTf
// module chunks = 2